import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { BlockShiftPuzzleComponent } from "./components/BlockShiftPuzzleComponent";
import { TimerComponent } from "./components/TimerComponent";
import PatternPuzzleComponent from "./components/PatternPuzzleComponent";
import { NumberQuizComponent } from "./components/NumberQuizComponent";
import { TipComponent } from "./components/TipComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("game-block-shift-puzzle", BlockShiftPuzzleComponent);
window.customElements.define("game-number-quiz", NumberQuizComponent);
window.customElements.define("timer-status", TimerComponent);
window.customElements.define("game-pattern-puzzle", PatternPuzzleComponent);
window.customElements.define("tip-quiz", TipComponent);
